import { IonGrid, IonInput, IonRow } from '@ionic/react';
import useComponentVisible from '../../../utils/useOuterClick';
import React, { useState, useEffect, useRef, MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BOBTAIL, 
  OTHER,
  trailersConfiguration,
  SNCZ,
  TRAILER_OUT
} from '../../../utils/constants';
import { validatingTrailerInput, restrictAlphaonKeyPress } from "./UpdateStop.util"
import { getSNIConfigTrailerdropdownDataValue, IONICWrapper } from 'app/utils/common';
import { IEShipmentResponse } from '../../../schemas/getShipment/GetShipment.schema';
import { getShipmentDetails } from '../../../selectors/Myload/selector';
import { useSelector } from 'react-redux';
export interface IComboxProps {
  value: string;
  onChange: (value: string) => void;
  showError: boolean;
  disabled: boolean;
  onFocus: (obj:any) => void;
  showDropDown: (show: boolean) => void;
  showOptions: boolean;
  mobile?: boolean;
  web?: boolean;
  dropdownType: string;
  stopType: string;
  sequenceNo:number;
  chasisNumber?:string;
  isDray?:boolean;
}
export const ComboBox: React.FunctionComponent<IComboxProps> = (props: IComboxProps) => {
  const [dropDownValues, setDropDownValues] = useState<any[]>([]);
  const [TValue, setTValue] = useState<string>("");
  const [trailerType, setTrailerType] = useState<string>("");
  const trailerPattern = /TA[\d]{6}|SNLU[\d]{6}|SNCZ[\d]{6}|BOBTAIL/;
  const refVariable = useRef<HTMLIonInputElement>() as MutableRefObject<HTMLIonInputElement>;
  const { t } = useTranslation();
  const shipmentDetails: IEShipmentResponse = useSelector(getShipmentDetails());
  const isDrayRoute = shipmentDetails
                            && shipmentDetails.shipments
                            && shipmentDetails.shipments.length > 0 
                            ? shipmentDetails.shipments[0].isDrayRoute : [];

  const updateTrailer = (value: string) => {

    if(!(!!value)){
      setTValue("");
      setTrailerType("");
      return;
    }

    const Tvalue = trailerPattern.test(value) ? value.toUpperCase() : value;

    if (Tvalue && Tvalue.indexOf(BOBTAIL) !== -1) {
      setTValue(Tvalue)
      return setTrailerType(BOBTAIL)
    } else if ((Tvalue && Tvalue.indexOf("SNLU") !== -1) || trailerType === "SNLU") {
      setTValue(Tvalue.slice(4))
      return setTrailerType("SNLU")
    } else if ((Tvalue && Tvalue.indexOf("SNCZ") !== -1) || trailerType === "SNCZ") {
      setTValue(Tvalue.slice(4))
      return setTrailerType("SNCZ")
    } else if ((Tvalue && Tvalue.indexOf("TA") !== -1) || trailerType === "TA") {
      setTValue(Tvalue.slice(2))
      return setTrailerType("TA")
    }
    else if ((Tvalue && Tvalue.indexOf(OTHER) !== -1)) {
      setTValue(Tvalue.slice(Tvalue.indexOf(OTHER) !== -1 ? 5 : 0));
      return setTrailerType(OTHER)
    } else {
      setTValue(value)
      return setTrailerType(value || trailerType === OTHER ? OTHER : "")
    }
  }
  
  useEffect(() => {
    updateTrailer(props.value)
  }, [props.value]);

  const handleInputChangeValidation = (event: any) => {
    event.target.value = trailerType && validatingTrailerInput[trailerType](event.target.value)
    const changedValue = trailerType === "TA" || trailerType === "SNLU" ||trailerType === "SNCZ" || trailerType === OTHER ? `${trailerType}${event.target.value}` : event.target.value.trim()
    setTValue(event.target.value.trim());
    if(trailerType && trailerType === "OTHER"){
    let maxLength = trailerType && (( getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).maxlength) ?(getSNIConfigTrailerdropdownDataValue(trailerType).maxlength) : trailersConfiguration[trailerType].maxlength);
    (event.target.value.length > maxLength) && (event.target.value = event.target.value .slice(0, maxLength));
    }
    if(trailerType !== "OTHER" && !props?.value?.includes(trailerType)){
      setTrailerType("OTHER");
      setTValue(props?.value);
      props.onChange(props?.value);
      return;
    }
    props.onChange(changedValue);
  }

  const handleTrailerSelection = (value: string) => {
    setTrailerType(value);
    setTValue(value === BOBTAIL ? BOBTAIL : "")
    props.showDropDown(false);
    props.onChange(value);
  }

  const handleOnClick = (e:any) => {
    if(!props.disabled){
      props.onFocus(e);
      if(trailerType==="" && TValue===""){
        props.showDropDown(true)
      }
    }
  }
  const { ref, isComponentVisible } = useComponentVisible(true);
  useEffect(()=>{
    if(isComponentVisible===false){
      props.showDropDown(isComponentVisible);
    }
  },[isComponentVisible])
  useEffect(()=>{
    setDropDownValues(dropDownFilterLogic())   
  },[props.dropdownType,props.stopType])
  const dropDownFilterLogic = (): any[] => {
    const _allConfigData: any = IONICWrapper.details?.keys?.configuration?.trailerDropdownData;
    const structuredData = _allConfigData && Object.entries(_allConfigData).map(([key, value]: any) => {
      return {
        key,
        trailerIn: value?.trailerIn,
        trailerOut: value?.trailerOut,
      }
    });
    const filteredData = structuredData?.filter((elem: any) => {
      return !(props.stopType === "P" && elem.key === "BOBTAIL" && props.sequenceNo != 1)
        && elem[props.dropdownType]?.includes(props.stopType);
    });

    const data = filteredData && filteredData.map((item: any) => item.key).filter((item : any) => {
      if((props.web ?props.isDray :isDrayRoute) && (props.chasisNumber === null || props.chasisNumber === "")
      && (props.dropdownType === TRAILER_OUT))
      return item 
      else return item !== SNCZ
    });
    return data || []
  }
  return (
    <>
      <div className="trailer-input-block">
        {
          trailerType &&
          ((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).showReadOnlyField) ?(getSNIConfigTrailerdropdownDataValue(trailerType).showReadOnlyField) : trailersConfiguration[trailerType].showReadOnlyField )&& <IonInput
            class={props.web ? "tariler-feild" : "tariler-feild-disabled"}
            value={trailerType}
            readonly
            style={{
              width: props.web ?
              ((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).webWidth) ?(getSNIConfigTrailerdropdownDataValue(trailerType).webWidth) : trailersConfiguration[trailerType].webWidth) || ((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).width) ?(getSNIConfigTrailerdropdownDataValue(trailerType).width) : trailersConfiguration[trailerType].width)
                : ((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).width) ?(getSNIConfigTrailerdropdownDataValue(trailerType).width) : trailersConfiguration[trailerType].width)
            }}
          />
        }
        <IonInput
          class={"tariler-feild"}
          value={TValue}
          onIonChange={event => handleInputChangeValidation(event)}
          disabled={props.disabled}
          onClick={(e)=>handleOnClick(e)}
          onKeyPress={event => trailerType !== "OTHER" ?  restrictAlphaonKeyPress(event) : {}}
          placeholder={trailerType && (
            ((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).placeholder) ?(getSNIConfigTrailerdropdownDataValue(trailerType).placeholder) : trailersConfiguration[trailerType].placeholder) || "")}
          ref={refVariable}
          inputmode={trailerType && (((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).keyBoardType) ?(getSNIConfigTrailerdropdownDataValue(trailerType).keyBoardType) : trailersConfiguration[trailerType].keyBoardType) || "text")}
          maxlength={trailerType && ((getSNIConfigTrailerdropdownDataValue(trailerType) && getSNIConfigTrailerdropdownDataValue(trailerType).maxlength) ?(getSNIConfigTrailerdropdownDataValue(trailerType).maxlength) : trailersConfiguration[trailerType].maxlength)}
          readonly={trailerType === "BOBTAIL" || trailerType === ""}
        />
      </div>
      {props.showOptions && !props.disabled && (
        <IonGrid class="option-grid" ref={ref}>
          {dropDownValues?.map((value: string, index: any) => (
              <IonRow
                onMouseDown={() => {
                  handleTrailerSelection(value)
                }}
                key={index}>
                {value}
              </IonRow>
            ))}
        </IonGrid>
      )}
      {props.showError && (
        <div className="pickupdate-error error-message" style={{ textAlign: 'left' }}>
          <p>{t('RequiredField')}</p>
        </div>
      )}
    </>
  );
};
